import api from "../services/api";
import {
  IPartnerApplication,
  ICreatePartnerApplication,
  IPartnerApplicationCreated,
} from "../models/IPartnerApplication";

export const getPartnerApplications = (): Promise<{ data: IPartnerApplication[] }> =>
  api.get("partner-applications");

export const getPartnerApplication = (id: string): Promise<{ data: IPartnerApplication }> =>
  api.get(`partner-applications/${id}`);

export const createPartnerApplication = (
  data: ICreatePartnerApplication
): Promise<{ data: IPartnerApplicationCreated }> => api.post("partner-applications", data);

export const rotatePartnerApplicationKey = (
  id: string
): Promise<{ data: IPartnerApplicationCreated }> => api.post(`partner-applications/${id}/rotate`);

export const revokePartnerApplication = (id: string): Promise<{ data: IPartnerApplication }> =>
  api.post(`partner-applications/${id}/revoke`);
